import React from 'react';
import TimeRangePickerList from '@components/time-range-picker-list/time-range-picker-list.tsx';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

function TimePickerComponent() {
  const handleTimeChange = (ranges: any) => {};
  const { t } = useTranslation();

  const existingData1 = [
    { start: dayjs().hour(9).minute(0), end: dayjs().hour(12).minute(0) }
  ];

  const existingData2 = [
    { start: dayjs().hour(9).minute(0), end: dayjs().hour(12).minute(0) },
    { start: dayjs().hour(13).minute(0), end: dayjs().hour(17).minute(0) }
  ];

  return (
    <div className="flex flex-col gap-10">
      <div className="max-w-[550px]">
        <TimeRangePickerList
          updateData={existingData1}
          onChange={handleTimeChange}
        />
      </div>

      <div className="max-w-[600px]">
        <TimeRangePickerList
          updateData={existingData2}
          onChange={handleTimeChange}
          mode={'multiple'}
        />
      </div>

      <div className="max-w-[600px]">
        <TimeRangePickerList
          updateData={existingData2}
          onChange={handleTimeChange}
          mode={'multiple'}
          required={true}
          helperText={t('validation_working_time_required')}
        />
      </div>
    </div>
  );
}

export default TimePickerComponent;
